import React, { Component } from "react";

export default class ExecutiveTeam extends Component {
  render() {
    return (
      <section id="team" className="section-profile">
        <div className="row">
          <div className="col-sm-12">
            <h2>Our Executive Team</h2>
            <h3>
              A team of talented, fun, and AGILE developers creating ongoing
              solutions for clients around the world.
            </h3>
          </div>
        </div>
        <div className="container">
          <div className="profileSquares">
            <div className="profile">
              <div className="profileWrapper">
                <div>
                  <img
                    src={require("../../assets/img/ralf_brockhaus.png")}
                    alt=""
                  />
                </div>
                <div className="profile-name">Ralf Brockhaus</div>
                <div className="profile-job"> CHIEF EXECUTIVE OFFICER</div>
                <div className="profile-desc">
                  <p>
                    Ralf founded Smilefish in early 2011. He holds a Master's
                    Degree in Computer Science and 20+ years of experience in
                    software development ranging from startup companies to
                    senior management positions at IBM.
                  </p>
                </div>
              </div>
            </div>
            <div className="profile">
              <div className="profileWrapper">
                <div>
                  <img
                    src={require("../../assets/img/frank_ayars.png")}
                    alt=""
                  />
                </div>
                <div className="profile-name">Frank Ayars</div>
                <div className="profile-job">DIRECTOR SOFTWARE DEVELOPMENT</div>
                <div className="profile-desc">
                  <p>
                    As a UC Riverside graduate of 1995, Frank has been
                    passionate for software development and managing projects.
                    Aside from work, he loves spending time with his extra large
                    family.
                  </p>
                </div>
              </div>
            </div>
            <div className="profile">
              <div className="profileWrapper">
                <div>
                  <img
                    src={require("../../assets/img/justin_toyama.png")}
                    alt=""
                  />
                </div>
                <div className="profile-name">Justin Toyama</div>
                <div className="profile-job">
                  PROJECT MANAGER/MOBILE DEVELOPER
                </div>
                <div className="profile-desc">
                  <p>
                    Justin is a Senior Project Manager and Lead iOS Developer.
                    He also teaches iOS Programming through University of
                    California, Irvine Extension.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}
